import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MdMailOutline, MdOutlinePhone } from 'react-icons/md'
import moment from 'moment'

import UserStatsModal from '../../users_list/user_stats_modal'

import * as Helpers from '../../../helpers/helper'
import * as Constants from '../../../helpers/constants'
import ClipboardCopy from '../../widgets/clipboard_copy'
import CustomOverlayTrigger from '../../widgets/overlay_trigger'

export const srNoFormatter = (item) => {
  return (
    <div style={{ textAlign: 'center' }}>
      {item.sr_no}
    </div>
  )
}

export const nameFormatter = (item, client) => {
  return (
    <div className='tags-user-list-name-cell-container'>
      <div className='pt-1 pb-3 d-flex align-items-center'>
        <CustomOverlayTrigger
          content={_getProjectStatus(item)}
          placement='top'
        >
          <FontAwesomeIcon
            icon={item.user_type === 'organization' ? 'fa-solid fa-users' : 'fa-solid fa-user'}
            style={{ color: _getIconColor(item) }}
          />
        </CustomOverlayTrigger>
        {item.name ? (
          <span className='ps-2'>
            <CustomOverlayTrigger
              content={item.name}
              placement='top'
            >
              <Link
                to={`/${client}/individual_user_info?user_id=${item._id}&user_type=${item.user_type}`}
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none tags-co-name-format'
              >
                {item.name}
              </Link>
            </CustomOverlayTrigger>
          </span>
        ) : (
          <span>-</span>
        )}
        <div className='ms-auto'>
          {_getPaidTag(item) ? (
            <Badge bg='success'>Paid</Badge>
          ) : null}
        </div>
      </div>
      <div className='tags-user-list-table-icon-wrapper'>
        <div className='pe-2'>
          <UserStatsModal
            cell={item}
            selectedUser={item}
            client={client}
          />
        </div>
        <div className='px-2'>
          <CustomOverlayTrigger
            content={`click here to get the activities of ${item.name || 'user'}`}
            placement='bottom'
          >
            <Link
              to={`/${client}/individual_user_activity?user_id=${item._id}`}
              target='_blank'
              className='text-decoration-none tags-co-name-cell-link'
            >
              <FontAwesomeIcon icon='fa-brands fa-wpexplorer' />
            </Link>
          </CustomOverlayTrigger>
        </div>
        <div className='px-2'>
          <CustomOverlayTrigger
            content={`Click here to view the matomo activity logs of ${item.name}`}
            placement='bottom'
          >
            <Link
              to={`${CLEAROUT_BASE_URL}/matomo/getvisitorprofile?user_id=${item._id}&site_id=${Constants.CLIENTS[client.toUpperCase()].MATOMO_SITE_ID}`}
              target='_blank'
              className='text-decoration-none tags-co-name-cell-link'
            >
              <FontAwesomeIcon icon='fa-solid fa-arrow-up-right-from-square' />
            </Link>
          </CustomOverlayTrigger>
        </div>
        <div className='px-2'>
          <CustomOverlayTrigger
            content={`Click here to get the email verifier lists of ${item.name}`}
            placement='bottom'
          >
            <Link
              to={`/${client}/email_verifier_lists?user_email=${encodeURIComponent(item.email)}`}
              target='_blank'
              rel="noopener noreferrer"
              className='text-decoration-none tags-co-name-cell-link'
            >
              <FontAwesomeIcon icon='fa-solid fa-sheet-plastic' />
            </Link>
          </CustomOverlayTrigger>
        </div>
        <div className='px-2'>
          <CustomOverlayTrigger
            content={`Click here to get the email finder lists of ${item.name}`}
            placement='bottom'
          >
            <Link
              to={`/${client}/email_finder_lists?user_email=${encodeURIComponent(item.email)}`}
              target='_blank'
              rel="noopener noreferrer"
              className='text-decoration-none tags-co-name-cell-link'
            >
              <FontAwesomeIcon icon='fa-solid fa-list-ul' />
            </Link>
          </CustomOverlayTrigger>
        </div>
        <div className='px-2'>
          <CustomOverlayTrigger
            content={`Click here to get the prospect lists of ${item.name}`}
            placement='bottom'
          >
            <Link
              to={`/${client}/prospect_lists?user_email=${encodeURIComponent(item.email)}`}
              target='_blank'
              rel="noopener noreferrer"
              className='text-decoration-none tags-co-name-cell-link'
            >
              <FontAwesomeIcon icon='fa-solid fa-rectangle-list' />
            </Link>
          </CustomOverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export const contactFormatter = (item, client) => {
  const name = item.name
  const email = item.email
  const phone = item.phone_number

  return (
    <div className="d-flex flex-column px-2 gap-1 email-cell">
      {/* Email Section */}
      <div className="d-flex align-items-center">
        <MdMailOutline className="me-2" />
        {name ? (
          <CustomOverlayTrigger
            placement={'top'}
            content={<span className="text-wrap">{email}</span>}
          >
            <span>{_.truncate(email, { length: 30, omission: '...' })}</span>
          </CustomOverlayTrigger>
        ) : (
          <Link
            to={`/${client}/individual_user_info?user_id=${item._id}&user_type=${item.user_type}`}
            className="custom-link"
          >
            <CustomOverlayTrigger
              placement={'top'}
              content={<span className="text-wrap" >{email}</span>}
            >
              <span>{_.truncate(email, { length: 30, omission: '...' })}</span>
            </CustomOverlayTrigger>
          </Link>
        )}
        <div className="ms-auto tags-user-list-table-icon-wrapper">
          <ClipboardCopy textToCopy={email} />
        </div>
      </div>
      {/* Phone Section */}
      <div className="d-flex align-items-center">
        <MdOutlinePhone className="me-2" />
        {phone ? <span>{phone}</span> : <span>-</span>}
        {phone ? (
          <div className="ms-auto tags-user-list-table-icon-wrapper">
            <ClipboardCopy textToCopy={phone} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export const userTagsFormatter = (item) => {
  const matchedTags = _.orderBy(_.get(item, 'user_tags.matched', []), ['display_name'], ['asc'])
  const otherTags = _.orderBy(_.get(item, 'user_tags.others', []), ['display_name'], ['asc'])

  if (matchedTags.length === 0 && otherTags.length === 0) {
    return <div className="d-flex flex-column px-2 gap-1 email-cell">-</div>
  }

  const getTagSection = (title, tags) => (
    <div key={title}>
      <div className='small'>{title}</div>
      <div className='d-flex flex-wrap gap-1'>
        {tags.map(tag => {
          const tagName = tag.display_name
          const color = Helpers.getTagColor(tagName)
          const tagDate = moment(tag.tagged_on).format('Do MMMM YYYY, h:mm:ss A')

          return (
            <CustomOverlayTrigger
              key={tagName}
              placement="top"
              content={tagDate}
            >
              <div
                className={`badge bg-${color}`}
                style={{ '--bs-bg-opacity': '0.7' }}
              >
                {tagName}
              </div>
            </CustomOverlayTrigger>
          )
        })}
      </div>
    </div>
  )

  const sections = []
  if (matchedTags.length > 0) sections.push(getTagSection('Filters Matched', matchedTags))
  if (otherTags.length > 0) sections.push(getTagSection('Other Active Tags', otherTags))

  return <div className='d-flex flex-column px-2 gap-1 email-cell'>{sections}</div>
}

export const creditsFormatter = (item) => {
  const total = item.credits?.total
  return (
    <div className="credits-format">
      Remaining Credits: {Helpers.isNumber(total) ? Number(total).toLocaleString() : '-'}
    </div>
  )
}

export const recurFormatter = (item) => {
  const recur = item.recur
  return (
    <div className="d-flex recur">
      {recur?.credits ? Helpers.getRecurTable(recur) : '-'}
    </div>
  )
}

export const lowCreditThresholdFormatter = (item) => {
  let data = '-'
  let thresholdSign = ''

  if (item.settings?.low_credit_balance) {
    data = item.settings.low_credit_balance.min_threshold

    if (data >= item.credits?.total) {
      thresholdSign = 'red'
    }
  }

  return (
    <div className="d-flex px-2">
      <span style={{ color: thresholdSign }}>
        {typeof data === 'number' ? data.toLocaleString() : data}
      </span>
    </div>
  )
}

export const roleFormatter = (item) => {
  const roleMap = { owner: 'Owner', analyst: 'Executive' }
  let role = item.user_role

  const formattedRole = role ? roleMap[role] || (role.charAt(0).toUpperCase() + role.slice(1)) : '-'

  return (
    <div className="px-2">
      {formattedRole}
    </div>
  )
}

export const userSourceFormatter = (item) => {
  return <div className="px-2">{item.user_source || '-'}</div>
}

export const channelSourceFormatter = (item) => {
  const source = item.channel_source?.[0]?.source
  const formatted = !_.isEmpty(source) ? source : '-'

  return <div className="d-flex px-2 text-capitalize">{formatted}</div>
}

export const channelSourceCampaignFormatter = () => (
  <div className="d-flex px-2">{'-'}</div>
)

export const channelSourceQueryFormatter = (item) => {
  const query = item.channel_source?.[0]?.url_params || '-'
  return <div className="d-flex px-2">{query}</div>
}

export const affiliateFormatter = (item) => {
  return <div className="d-flex px-2">{item.affiliate || '-'}</div>
}

export const signUpIpFormatter = (item) => {
  return <div className="px-2">{item.ip || '-'}</div>
}

export const signUpCountryFormatterer = (item) => (
  <div className="px-2">{item.country || '-'}</div>
)

export const activatedOnFormatter = (item) => {
  const activated = item.activated_on

  let date
  if (activated && activated !== 'Yet to Activate') {
    date = Helpers.formatDate(activated, 'DD-MMM-YYYY @ h:mm:ss a')
  } else {
    date = 'Yet to Activate'
  }

  return (
    <div className="d-flex px-2 activated_on">
      <span title={date}>{date}</span>
    </div>
  )
}

export const createdOnFormatter = (item) => {
  const created = item.created_on

  return (
    <div className="d-flex px-2 created_on">
      {created ? (
        <span title={created}>
          {Helpers.formatDate(created, 'DD-MMM-YYYY @ h:mm:ss a')}
        </span>
      ) : (
        <span>-</span>
      )}
    </div>
  )
}

export const accountDeleteReasonFormatter = (item) => {
  const dltReason = item.deleted_reason

  let reason
  if (dltReason) {
    reason = Constants.ACCOUNT_DELETE_REASONS[dltReason] || Helpers.capitalizeFirstLetter(dltReason)
  } else {
    reason = '-'
  }

  return (
    <div className="px-2">
      {reason}
    </div>
  )
}

export const userIdFormatter = (item) => {
  return <div className="pl-2">{item._id || '-'}</div>
}

const _getProjectStatus = (row) => {
  if (row.account_status === 'removed') {
    return 'Removed'
  } else if (!row.activated_on || row.activated_on === 'Yet to Activate') {
    return 'Yet to activate'
  } else if (row.status === 'active') {
    return 'Active'
  } else {
    return 'Inactive'
  }
}

const _getIconColor = (row) => {
  if (row.account_status === 'removed') {
    return '#ff6767'
  } else if (!row.activated_on || row.activated_on === 'Yet to Activate') {
    return '#a3a3a3'
  } else if (row.status === 'active') {
    return '#198754'
  } else {
    return '#e48725'
  }
}

const _getPaidTag = (user) => {
  let isPaid = false
  if (user.tags && user.tags.length > 0) {
    isPaid = user.tags.includes('paid')
  }
  return isPaid
}